module.exports = __webpack_public_path__ + "img/slika65.14fbcf76.jpg";